import { render, staticRenderFns } from "./activityPop.vue?vue&type=template&id=4b1320b8&scoped=true"
import script from "./activityPop.vue?vue&type=script&lang=js"
export * from "./activityPop.vue?vue&type=script&lang=js"
import style0 from "./activityPop.vue?vue&type=style&index=0&id=4b1320b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1320b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1320b8')) {
      api.createRecord('4b1320b8', component.options)
    } else {
      api.reload('4b1320b8', component.options)
    }
    module.hot.accept("./activityPop.vue?vue&type=template&id=4b1320b8&scoped=true", function () {
      api.rerender('4b1320b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/brandSelection/components/activityPop.vue"
export default component.exports